<template>
  <div class="container-pronosticoClima">
    <div class="wrapper-spin" :class="{ 'd-none': isLoaded }" id="spinner">
      <div class="spin">
        <img src="/images/icons/spin.png" alt="Spinner">
      </div>
    </div>
    <div @click="handleClickOutside" ref="customSelectWrapper">
      <div
        class="wrapper-select-search w-100 d-flex flex-column flex-lg-row align-items-center py-4 py-lg-5 mt-4 mt-lg-4 mb-3 mb-md-0">
        <h5 class="font-PB fw-bold text-lightGray5 text-nowrap pe-2 mb-2 mb-lg-0 h5-1">Ver clima de:</h5>
        <div class="col max-w-450 w-100">
          <!--Custom Select recibe track-by en vez de :trackBy porque paso un string como prop, no un valor dinamico del componente-->
          <custom-select ref="customSelect" track-by="name" is-clima="true" size="full"
            :remote="true" @getClima="getPronostico" v-model="selectedLocation" :searchable="true"></custom-select>
        </div>
      </div>
    </div>
    <div class="sliderClima mt-2 mb-5">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="row justify-content-center">
            <div class="col-lg-11 px-0 px-lg-3">
              <div class="swiper-container overflow-hidden mx-0 mx-md-2">
                <div class="swiper-wrapper align-items-center">
                  <div class="swiper-slide d-flex align-items-center col-6 col-sm-4 col-md-4 col-lg-3 col-xl px-2"
                    v-for="clima in climasList">
                    <div class="card w-100 text-center border-0 line-down overflow-hidden mx-0"
                      @click="selectCard(clima.id)" :class="{ today: clima.id == 1, active: isActive == clima.id }">
                      <div class="card-header bg-tertiary2 border-0 py-3">
                        <h5 class="font-PB text-tertiary mb-0">{{ clima.dia }}</h5>
                        <h4 class="font-PB text-tertiary mb-0">{{ clima.fecha }}</h4>
                      </div>
                      <div class="card-body pt-2">
                        <h4 class="card-title font-A20 text-muted text-nowrap">{{ clima.temperatura.min }}º /
                          {{ clima.temperatura.max }}º</h4>
                        <img v-if="clima.id == 1" v-bind:src="'/images/icons/clima/green/' + clima.img.id + '.svg'"
                          :alt="clima.img.name" class="me-2">
                        <img v-if="clima.id != 1" v-bind:src="'/images/icons/clima/' + clima.img.id + '.svg'"
                          :alt="clima.img.name" class="me-2">
                      </div>
                    </div>
                  </div>
                </div>
                <div class="swiper-pagination"></div>
              </div>
            </div>
          </div>
          <div class="swiper-button-next d-none d-lg-block">
            <div class="ico-circle-left text-white hover-moveLeft">
              <img src="/images/icons/arrow-circle-outline.png" alt="">
            </div>
          </div>
          <div class="swiper-button-prev d-none d-lg-block">
            <div class="ico-circle-left ico-circle-outline text-white hover-moveLeft">
              <img src="/images/icons/arrow-circle-outline.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="wrapper-cards pt-2 mb-4">
      <div class="row justify-content-center">
        <div class="col-md-12">
          <div class="row justify-content-center">
            <div class="col-sm-6 col-lg-4 col-xl-3 mb-3" v-for="(turno, index) in turnosList[0]">
              <div class="card cards-clima line-down rounded-sm shadow w-100 px-0 mb-3">
                <div class="card-header bg-tertiary">
                  <h5 class="font-PB text-white text-center mb-0">{{ turno.name }}</h5>
                </div>
                <div class="card-body green p-0">

                  <ul class="list-group list-group-flush">
                    <li class="list-group-item d-flex align-items-center pt-3 pb-2"
                      v-for="(property, index) in turno.properties">
                      <div class="container">
                        <div class="row">
                          <div class="col-7 px-0">
                            <div class="mb-2" v-if="property.img != ''">
                              <img v-bind:src="'/images/icons/clima/turnos/' + property.img + '.svg'"
                                :alt="property.img">
                            </div>
                            <p class="font-ARB text-lightGray5 mb-0">{{ index }}</p>
                          </div>
                          <div class="col-5 px-0 d-flex justify-content-end align-items-center">
                            <div v-if="index != 'Apto Pulverizar'">
                              <p class="font-AR text-lightGray4 mb-0 fw-bold">{{ property.value }}<sup
                                  v-if="index == 'Viento'">1</sup></p>
                            </div>
                            <div v-if="index == 'Apto Pulverizar'"
                              :class="{ 'bg-tertiary': property.value == 'workable', 'bg-danger': property.value == 'unworkable', 'bg-warning': property.value == 'caution' }"
                              class="rounded-pill d-flex justify-content-center align-items-center px-3 py-2">
                              <p v-if="property.value == 'caution'"
                                class="small font-ARM text-lightGray5 fw-bold text-nowrap text-uppercase mb-0">
                                Precaución</p>
                              <p v-if="property.value == 'unworkable'"
                                class="small font-ARM text-white fw-bold text-nowrap text-uppercase mb-0">No
                                Apto</p>
                              <p v-if="property.value == 'workable'"
                                class="small font-ARM text-white fw-bold text-nowrap text-uppercase mb-0">
                                Aplicable</p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>

                </div>
              </div>
            </div>
          </div>
          <p v-if="turnosList[0] != null" class="leyenda small font-AR text-lightGray4 text-center">
            <sup>(1)</sup>N=Norte, NE=Noreste, E=Este, SE=Sureste, S=Sur, SO=Suroeste, O=Oeste, NO=Noroeste
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  async mounted() {
    // 1. Revisa geolocalización
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          const { latitude, longitude } = position.coords;
          try {
            // Reverse-geocode browser coordinates to the nearest named location
            const { data } = await axios.get('/api/location', {
              params: { lat: latitude, lon: longitude }
            });
            // Update the select label and fetch weather for that location
            this.selectedLocation = data;
            this.getPronostico(data.coordinates.lat, data.coordinates.lon);
          } catch (e) {
            console.error('No se pudo obtener la ubicación:', e.message);
            this.selectedLocation = this.location;
          }
        },
        (error) => {
          console.error('Falló geolocalización por el siguiente error:', error.message);
          // Setea ubicación por defecto si la geolocalización falla
          this.selectedLocation = this.location;
        }
      );
    } else {
      // Setea ubicacion por defecto si no esta disponible la geolocalización
      this.selectedLocation = this.location;
    }

    // 3. Carga completa del componente y esconde spinner
    this.isLoaded = true;
  },
  props: ['climas', 'location'],
  methods: {
    selectCard: function (selected) {
      //Update turnos list
      this.turnosList = this.climasList.find(element => element.id == selected)['turnos'];
      //Set clima active
      this.isActive = selected;
    },
    /**
     * Get pronostico.
     *
     * @param  {string} lat Latitude
     * @param  {string} lon Longitude
     * @return void
     */
    getPronostico: async function (lat, lon) {

      //Show spinner
      $('#spinner').removeClass('d-none');

      //Get data
      axios.get('/api/clima', { params: { lat: lat, lon: lon } })
        .then(function (response) {
          //Update climas list
          this.climasList = response.data;
          //Select card
          this.selectCard(1); //Select first card
          //Hide spinner
          $('#spinner').addClass('d-none');
        }.bind(this));
    },
    /**
     * Ask browser for location coordinates.
     *
     * @return void
     */
    geolocation: function () {
      let parent = this;
      //Check browser compatibility
      if (!navigator.geolocation) {
        console.log('El navegador no tiene soporte para geolocalización.');
      } else {
        //Use geolocation
        navigator.geolocation.getCurrentPosition(function (position) {
          const latitude = position.coords.latitude;
          const longitude = position.coords.longitude;
          //Get pronostico data
          parent.getPronostico(latitude, longitude);
        }, function () {
          console.error('No es posible realizar la geolocalización.');
        });
      }
    },
    handleClickOutside(event) {
      if (!this.$refs.customSelect.$el.contains(event.target)) {
        //Cuando se hace click en el área fuera del custom-select, dispara toggleDropdown dentro del mismo
        this.$refs.customSelect.toggleDropdown(false);
        event.stopPropagation();
      }
    },
  },
  data() {
    return {
      isTurno: null,
      isActive: 1,
      value: this.location,
      climasList: this.climas,
      turnosList: this.climas.find(element => element.id == 1)['turnos'],
      isLoaded: false,
      selectedLocation: this.location,
    }
  }
};
</script>